var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVirtualTourIcon = function SvgVirtualTourIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95.491,
    height: 62.069,
    viewBox: "0 0 95.491 62.069",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ca0928;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-72.178,2517.748c-26.355,0-47.746,10.695-47.746,23.873,0,10.695,14.037,19.719,33.422,22.774v15.422l19.1-19.1-19.1-19.1v13.035c-15.04-2.674-23.873-9.072-23.873-13.035,0-5.061,14.514-14.323,38.2-14.323s38.2,9.262,38.2,14.323c0,3.486-6.971,9.024-19.1,12.08v9.788c16.855-3.676,28.648-12.08,28.648-21.868C-24.433,2528.443-45.823,2517.748-72.178,2517.748Z",
    transform: "translate(119.924 -2517.748)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVirtualTourIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/virtual-tour-icon.549ba5f3.svg";
export { ForwardRef as ReactComponent };